(function(){
    angular
        .module('appback')
        .filter('formatearNumero', formatearNumero);
  
        formatearNumero.$inject = ['$filter'];
        function formatearNumero($filter) { 
            return function(input, fractionSize) {
                //console.log("input filter formatearnumero", input, fractionSize);
                if (input === null || input === undefined || isNaN(parseFloat(input))) {
                    return input;
                }

                if (parseFloat(input) === 0) {
                    return '0';
                }

                var maxFractionSize = (fractionSize === undefined) ? 4 : fractionSize;
                var number = parseFloat(input);

                // Formatear el número usando la localización 'de-DE' que usa '.' para miles y ',' para decimales.
                var formattedNumber = new Intl.NumberFormat('de-DE', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: maxFractionSize
                }).format(number);

                return formattedNumber;
            }
        }
  })();